import { render, staticRenderFns } from "./RPDonutChart.vue?vue&type=template&id=60f40f33&"
import script from "./RPDonutChart.vue?vue&type=script&lang=js&"
export * from "./RPDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./RPDonutChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports